import { CircleHelpIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type FieldsetTitleProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  hasBadge?: boolean;
  integrationActive?: boolean;
  tooltip?: string;
};

const variantClasses = {
  primary: 'text-lg font-semibold leading-none tracking-[-0.45px] text-foreground',
  secondary: 'text-sm font-medium leading-none text-muted-foreground',
};

const FieldsetTitle = ({
  children,
  variant = 'primary',
  className,
  hasBadge,
  integrationActive,
  tooltip,
}: FieldsetTitleProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn('flex items-center gap-1', variantClasses[variant], className)}>
      <span className="px-1.5">{children}</span>
      {hasBadge && (
        <Badge type="secondary" flavour={integrationActive ? 'successful' : 'warning'}>
          {integrationActive
            ? t('integrations.fieldsets.active_fieldset.active')
            : t('integrations.fieldsets.active_fieldset.inactive')}
        </Badge>
      )}
      {tooltip && (
        <InfoTooltip content={tooltip} side="right">
          <CircleHelpIcon size={12} className="text-muted-foreground" />
        </InfoTooltip>
      )}
    </div>
  );
};

export default FieldsetTitle;
